<template>
  <div class="traing_manager-root">
    <div class="main-content-wrap">
      <div class="left-wrap">
        <div class="icon" style="margin-bottom: 10px;cursor:pointer;display: flex;align-items: center;margin-right:105px" @click="goBack">
          <v-icon name="regular/arrow-alt-circle-left" scale="1.5"></v-icon>
          <span style="margin-left:5px">返回</span>
        </div>
        <img :src="orgInfo.profile_picture" @error="logoImgLoadErr" class="traing-logo">
        <p class="traing-name text-line">{{orgInfo.name}}</p>
        <p class="traing-num text-line">培训班数量：{{orgInfo.finish_class_num}}</p>

        <template v-if="isFive">
          <span class="create-btn zuxie-btn whitebd w150" @click="classApplication">培训班开班申请</span>
          <span class="create-btn zuxie-btn whitebd w150" @click="beforeCreate" v-if="orgInfo.class_authorization_five">创建五人制培训班</span>
          <!--<span class="learner-btn zuxie-btn whitebd w150" @click="stusTutorial">五人制学员教案</span>-->

          <!-- <span class="goto_enroll_list zuxie-btn whitebd w150" @click="addFunc">添加文件存档</span> -->
          <!--<span class="goto_enroll_list zuxie-btn whitebd w150" @click="viewDocuments">查看文件存档</span>-->
        </template>
        <template v-else>
          <!--<span v-if="isShowStatistical" class="goto_enroll_list zuxie-btn whitebd" @click="jumpToStatistical">大数据</span>-->
          <span class="goto_enroll_list zuxie-btn whitebd" @click="goForClassPlane">开班计划</span>
          <span class="create-btn zuxie-btn whitebd" @click="beforeCreate" v-if="orgInfo.class_authorization">创建培训班</span>
          <!--<span class="train-btn zuxie-btn whitebd"  @click="trainManager" >-->
            <!--<el-badge :is-dot="isDot">高端培训报名</el-badge>-->
          <!--</span>-->
          <!--<span class="learner-btn zuxie-btn whitebd" @click="stusTutorial">学员教案</span>-->
          <span class="download-btn zuxie-btn whitebd" @click="downloadTemplate">报名通知模板</span>
          <!--<span class="goto_enroll_list zuxie-btn whitebd" @click="gotoEnrollList">-->
            <!--<el-badge :is-dot="transferNum">-->
              <!--注册教练员-->
            <!--</el-badge>-->
          <!--</span>-->
          <!-- <span class="goto_enroll_list zuxie-btn whitebd" @click="addFunc">添加文件存档</span> -->
          <!--<span class="goto_enroll_list zuxie-btn whitebd" @click="viewDocuments">查看文件存档</span>-->
          <span class="goto_enroll_list zuxie-btn whitebd" @click="goForHeighClassPlane">培训举办地管理</span>

        </template>


        <!-- <span class="down-btn zuxie-btn" @click="loadStuAcc">生成演示帐号</span> -->
      </div>
      <div class="right-wrap">
        <div class="content-header">
          <!--<span class="title"><strong>培训班管理</strong></span>-->

          <div class="input-group-wrap">
            <select class="select classType" v-model="calssTrainTypeSelVal" @change="levelSelChangeHandle">
              <option value>全部类型</option>
              <option
                v-for="item in calssTrainTypeList"
                :value="item.value"
                :key="item.value"
              >{{item.key}}</option>
            </select>
            <select class="select level" v-model="calssLevelSelVal" @change="levelSelChangeHandle">
              <option value>全部级别</option>
              <option
                v-for="item in levelSelList"
                :value="item.value"
                :key="item.value"
              >{{item.key}}</option>
            </select>
            <select class="select date" v-model="dateSelVal" @change="dateSelChangeHandle">
              <option value>全部培训时间</option>
              <option v-for="item in dateSelList" :value="item.value" :key="item.value">{{item.key}}</option>
            </select>
            <select class="select statu" v-model="statuSelVal" @change="statuSelChangeHandle">
              <option value>全部状态</option>
              <option
                v-for="item in statuSelList"
                :value="item.value"
                :key="item.value"
              >{{item.key}}</option>
            </select>
          </div>
        </div>
        <template v-show="!showEmpty">
          <div class="list-wrap">
            <yioks-loading v-show="isLoading"></yioks-loading>
            <div class="scroll-wrap" v-if="!isLoading">
              <vue-scroll :ops="vuescrollOpt" ref="vs">
                <div class="list-content">
                  <yioks-class-info
                    class="traing-wrap"
                    v-for="(traing) in trainingList"
                    :key="traing.c_id"
                    :traing="traing"
                  >
                  <!-- :isFive="isFive" -->
                    <div class="btn-wrap">
                      <button
                        class="btn zuxie-btn detail-btn"
                        type="buttom"
                        @click="toClassDetail(traing)"
                      >查看详情</button>
                      <button
                        class="btn zuxie-btn result-btn detail-btn"
                        type="buttom"
                        @click="viewResult(traing.msg_info)"
                        v-if="Number(traing.isShowAuditMsg) === 1">培训班审核结果</button>
                      <button
                        class="btn zuxie-btn result-btn detail-btn"
                        type="buttom"
                        @click="viewRefusedName(traing.refusedName,traing.name)"
                        v-if="Number(traing.isShowRefusedName) === 1">信息退回人员</button>
                    </div>

                  </yioks-class-info>
                </div>
              </vue-scroll>
            </div>
          </div>
          <div class="pagation-wrap" v-if="!isLoading">
            <yioks-paging :paging="paging" @goto-page="gotoPage($event)"></yioks-paging>
          </div>
        </template>
        <yioks-empty class="empty-box" h="auto" v-show="showEmpty"></yioks-empty>
        <el-dialog width="350px"
          :visible.sync="verifyResult"
          custom-class="verify_result_dialog"
          :close-on-click-modal="false">
          <div class="verifyResult">
            <p>审核结果：{{verifyMsg.audit_status | verifyStatus}}</p>
            <p>
              <span>审核理由：</span>
              <span>{{verifyMsg.audit_msg||'--'}}</span>
            </p>
          </div>
        </el-dialog>
        <el-dialog width="450px"
          :visible.sync="refusedName"
          custom-class="verify_result_dialog"
          :close-on-click-modal="false">
          <div class="verifyResult">
            <p>{{refusedNameMsg.class_name}}</p>
            <p>信息审核（照片、姓名拼音等）不合格：{{refusedNameMsg.names.length}} 人</p>
            <p v-for="name in refusedNameMsg.names">
              <span>{{name.name}}（电话：{{name.mobile_phone}}）</span>
            </p>
          </div>
        </el-dialog>
        <el-dialog width="550px"
                   :visible.sync="levelFlag"
                   custom-class="verify_result_dialog"
                   :close-on-click-modal="false">
          <div class="select-level">
            <p class="title">请选择培训班级别：</p>
            <div class="radio-wrap">
              <el-form ref="levelForm"
                       :model="levelForm"
                       :rules="levelRules">
                <el-form-item prop="level">
                  <el-radio-group v-model="levelForm.level">
                    <el-radio v-for="item in levelOptions"
                              :label="item.label" :key="item.label"
                              :disabled="item.label === 'L2' || item.label === 'L3'"
                              border>{{item.name}}</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-form>
            </div>
            <div class="btns">
              <el-button class="button"
                         type="primary"
                         @click="doSubmit(isFive)">确定</el-button>
              <el-button class="button"
                         type="danger"
                         @click="doCancel">取消</el-button>
            </div>
          </div>
        </el-dialog>
        <el-dialog class="eval-dialog"
          :visible.sync="allDisabled"
          title
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          :show-close="false"
          width="460px"
          center>
          <div class="to-eval">
            <div class="img">
              <img src="@/assets/images/evaluation_tips.png" alt>
            </div>
            <div class="tips">
              <p v-html="tips.title"></p>
            </div>
            <el-button type="primary" @click="gotoSetting">{{tips.button_text}}</el-button>
          </div>
        </el-dialog>
        <template v-if="add_show">
          <add-dialog :showAddDialog="add_show" :Info="{name:orgInfo.org_abbreviation,id_number:orgInfo.org_id,mobile_phone:'',object_type:'organ'}" @hideTips="hideAddDocumentTips"></add-dialog>
        </template>
      </div>
    </div>
    <!-- <update-dia :if-show='ifUpDiaShow' @close='closeDia'></update-dia> -->
  </div>
</template>

<script>
import createScrollOpt from "@/assets/js/vuescrollOption";
import {enroll_personnel_num} from "@/api/ab_signup/api";
import { getDocumentList } from '@/api/document/document';
import { correctStatus } from "@/assets/js/apiStatus";
import { date, manager_status,classLevelList, classLevelListForGoalkeeper,classLevelListForPhysical, classLevelListFive, class_train_type_list, class_train_type_list_five, org_create_class_avaible, org_create_class_avaible_five } from "@/assets/js/select";
import { getTraningList, getOrganizationInfo,loadStuAccount } from "@/api/agency/agency";
import { mapMutations, mapActions, mapGetters } from "vuex";
import {questionCheck} from "@/api/survey/index";
import chinaAssImg from "@/assets/images/org_logo.png";
import commonFun from "@/assets/js/yioks";
import fiveMixins from "@/minix/fiveMixins";
import {evaluationNum} from "@/api/common/api";
const { downfile } = commonFun;
const HOSTURL = process.env.VUE_APP_URL;
const testType = value =>
  Object.prototype.toString
    .call(value)
    .slice(8, -1)
    .toLocaleLowerCase();
export default {
  name: "TrainingCourseList",
  mixins: [ fiveMixins],
  components: {
    "yioks-paging": () => import("@/components/Pagination/Page"),
    "yioks-loading": () => import("@/components/Loading/Loading"),
    "yioks-empty": () => import("@/components/Tips/Empty"),
    "yioks-class-info": () => import("@/components/ClassInfoBox/ClassInfoBox"),
    "add-dialog": () => import('@/views/Documents/components/AddDialog'),
    "v-icon": () => import("vue-awesome/components/Icon"),
    "update-dia": () => import("@/components/UpdateDia/UpdateDia")
  },
  beforeCreate() {
    localStorage.getItem('sys_update') === null && localStorage.setItem('sys_update', '1');
  },
  data() {
    const rules = {
      level: [
        {
          required: true,
          message: "请选择培训班级别",
          trigger: "change"
        }
      ]
    };
    return {
      isDocumentExit: false,
      ifUpDiaShow: localStorage.getItem('sys_update') === '1',
      isLoading: true,
      isDot:false,
      allDisabled: false,
      add_show:false,
      survey_id:'',
      isSurvey:0,
      eva_c_id:0,
      tips:{
        title:"",
        button_text:"",
        show_type:"",
      },
      showCreateClass:false,
      // showList: false,
      showEmpty: false,
      verifyResult: false,
      refusedName: false,
      dateSelList: date,
      statuSelList: manager_status,
      levelSelList: [],
      calssTrainTypeList: [],
      dateSelVal: "",
      statuSelVal: "",
      calssLevelSelVal: "",
      calssTrainTypeSelVal: "",
      trainingList: [],
      verifyMsg: {},
      refusedNameMsg: {
        names:[],
        class_name:""
      },
      thePage: 1,
      orgInfo: {},
      paging: {
        start: 0,
        prePage: 1, // 一页多少条数据
        total: 1, // 总页数
        size: 3, // 页码显示限制
        last: true, // 尾页
        first: true, // 首页
        next: true, // 下一页
        previous: true, // 上一页
        jump: true
      },
      vuescrollOpt: createScrollOpt(),
      levelFlag: false,
      levelForm: {
        level: "",
      },
      levelRules: rules,
      levelOptions: [], // 创建班级可选列表
      transferNum: false,
    };
  },
  filters: {
    verifyStatus(status) {
      const statusHash = {
        "pass": "通过",
        "repulse": "拒绝",
        "pause": "暂停",
      };
      return !status ? "--" : statusHash[status];
    },
  },
  created() {
    this.getPersonnelum()
    this.setData();
    this.getEvaNum();
    this.getList();
    this.questionCheck();
    // this.getOrgInfo();
    // 如果当前 vuex 中不存在 培训班的数据，则触发相应的 action 获取机构数据
    // if (this.getStoreOrgData === null) this.actionStoreOrgData();
    this.actionStoreOrgData(); // 不管了，每次都请求，强制更新数据
    this.checkDocumentExit();

    if(this.isFive) {
      this.calssTrainTypeList = class_train_type_list_five;
      this.levelSelList = classLevelListFive;
      this.levelOptions = org_create_class_avaible_five;
    } else {
      this.calssTrainTypeList = class_train_type_list;
      this.levelSelList = classLevelList.concat(classLevelListForGoalkeeper).concat(classLevelListForPhysical);
      this.levelOptions = org_create_class_avaible;
    }
  },
  watch: {
    getStoreOrgData: {
      handler(val) {
        if (testType(val) === "object") {
          this.orgInfo = { ...val };
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    goBack(){
      this.$router.go(-1)
    },
    getEvaNum() {
      evaluationNum({})
      .then(({data})=>{
        // console.log(data);
        // 更新vuex测评数量
        if(Number(data.status) === 0 ){
          this.$store.commit("updateEvaNum", Number(data.result.eva_status_N)||0);
          
          // 如果是11人制 强制弹框写调查
          if(!this.isFive && data.result.eva_show_Cid && data.result.eva_show_Cid > 0){
            this.allDisabled = true ;
            this.tips.title= data.result.eva_show_CName+ "已经结束，请您填写问卷调查。";
            this.tips.button_text="前往问卷调查";
            this.tips.show_type="eva_show";
            this.eva_c_id = data.result.eva_show_Cid;
          }
        }
      })
      .catch((err)=>{
        console.error(err);
      });
    },
    questionCheck(){
      questionCheck().then(({data}) => {
        const { isSurvey, question } = data.result;
        this.isSurvey = isSurvey;
        if(question) this.survey_id = question.survey_id;
        if(Number(this.isSurvey)===1){
          this.allDisabled =true
          this.tips.title="有一份问卷调查需要您完成填写。";
          this.tips.button_text="前往问卷调查";
          this.tips.show_type="survey";
        }
      });
    },
    gotoSetting(){
      if(this.tips.show_type === 'survey'){
        this.$router.push({
          path: "/survey/survey_index",
          query: {survey_id:this.survey_id}
        });
      }
      else if(this.tips.show_type === 'eva_show'){
//        this.$router.push({
//          path: "create_evaluation",
//          query: {c_id:this.eva_c_id}
//        });
        this.$router.push({
          name: "OrgCreateEvaluation",
          params: { classId: this.eva_c_id }
        });
      }
    },
    getPersonnelum(){
      enroll_personnel_num({

      }).then(res=>{
        if (res.data.status===0){
          const {checkNum, transferNum}=res.data.result;
          this.transferNum = !!transferNum;
          this.isDot=!!checkNum;
        } else{
          this.$message.error(res.data.msg)
        }
      }).catch(err=>{
        console.log(err)
      })
    },
    closeDia() {
      localStorage.setItem('sys_update', '0');
      this.ifUpDiaShow = false;
    },
    setData() {
      const {page, create_time, status,class_level,class_train_type} = this.$route.query;
      page && (this.thePage = page);
      create_time && (this.dateSelVal = create_time);
      status && (this.statuSelVal = status);
      class_level && (this.calssLevelSelVal = class_level);
      class_train_type && (this.calssTrainTypeSelVal = class_train_type);
    },
    ...mapMutations(["setStoreAgencyName"]),
    ...mapActions(["actionStoreOrgData"]),
    logoImgLoadErr() {
      console.log("图片加载失败");
      this.orgInfo.profile_picture = chinaAssImg;
    },
    // 获取培训班列表数据
    getList() {
      this.showEmpty = false;
      // this.showList = false;
      this.isLoading = true;
      getTraningList({
        page: this.thePage,
        create_time: this.dateSelVal,
        status: this.statuSelVal,
        class_level: this.calssLevelSelVal,
        class_train_type: this.calssTrainTypeSelVal,
        province_id: "",
        city_id: ""
      })
        .then(({ data }) => {
          this.isLoading = false;
          if (data.status === correctStatus) {
            const result = data.result;
            this.trainingList = result.list.map(item => ({
              c_id: item.c_id,
              periods: item.periods,
              lecturer_assistant_name: item.lecturer_assistant_name,
              name: item.name,
              is_special_train: item.is_special_train,
              class_level: item.class_level,
              moment_picture: item.moment_picture
                ? HOSTURL + item.moment_picture
                : "",
              status: item.status,
              start_date: item.start_date,
              end_date: item.end_date,
              hours: item.hours,
              teacher_off_name: item.teacher_off_name,
              teacher_name: item.teacher_name,
              intern_teacher: item.intern_teacher,
              teacher_zhuli_names: item.teacher_zhuli_names,
              isShowAuditMsg : item.isShowAuditMsg,
              class_train_type : item.class_train_type,
              isShowRefusedName : item.isShowRefusedName || 0,
              refusedName : item.refusedName || [],
              msg_info : (Number(item.isShowAuditMsg)===1) && item.msg_info,
            }));
            this.$set(this.paging, "prePage", result.page.page_size);
            this.$set(this.paging, "total", result.page.total_row);
            this.$set(this.paging, "start", (this.thePage - 1) * this.paging.prePage);
          }
          this.showEmpty = this.trainingList.length <= 0;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    // 获取培训班资料信息
    /*getOrgInfo() {
      getOrganizationInfo({}).then(({ data }) => {
        if (data.status === correctStatus) {
          const { result } = data;
          const {
            profile_picture,
            class_train_num,
            name
          } = result.organization_info;
          this.$set(
            this.orgInfo,
            "profile_picture",
            profile_picture ? HOSTURL + profile_picture : ""
          );
          this.$set(this.orgInfo, "name", name);
          this.$set(this.orgInfo, "class_train_num", class_train_num);
          // 在状态管理中保存机构名称，在创建培训班页面中有用到
          this.setStoreAgencyName(name);
        }
      });
    },*/
    // 时间筛选下拉框的change事件函数
    dateSelChangeHandle() {
      this.changeQuery(true);
    },
    // 状态筛选下拉框的change事件函数
    statuSelChangeHandle() {
      this.changeQuery(true);
    },
    // 状态筛选下拉框的change事件函数
    levelSelChangeHandle() {
      this.changeQuery(true);
    },
    stusTutorial() {
      /*this.$router.push({
        name: "AllStusTutorial",
        params: { classId: this.classId, userId: "" }
      });*/
      this.$router.push({
        path: "all_stus_tutorial",
        query: {
          classId: this.classId,
        }
      });
    },
    trainManager() {
      this.$router.push({
        path: "train_registration_manager",
        query: {}
      });
    },
    //下载通知模板
    downloadTemplate(){
      downfile('/uploads/import_tpl/报名通知模板.docx')
    },
    // 查看详情
    toClassDetail(traingItem) {
      /*this.$router.push({
        name: "TrainingClassDetail",
        params: { classId: traingItem.c_id }
      });*/
      this.$router.push({
        path: "class_detail",
        query: {
          classId: traingItem.c_id
        }
      });
    },
    beforeCreate() {
//      if(this.isFive) {
//        // 五人制默认选择初级
//        this.$set(this.levelForm, 'level', 'early')
//      } else {
//        this.$set(this.levelForm, 'level', '')
//      }
      this.levelFlag = true;
    },
    classApplication(){
      this.$router.push({
        path: "class_application",
      });
    },
    // 分页插件的一个事件
    gotoPage(start) {
      this.thePage = parseInt(start / this.paging.prePage) + 1;
      this.changeQuery(false);
      this.$refs['vs'].scrollTo({ y: 0 });
    },
    viewResult(obj){
      this.verifyResult = true;
      this.verifyMsg = obj;
    },
    viewRefusedName(obj,name){
      this.refusedName = true;
      this.refusedNameMsg.names = obj;
      this.refusedNameMsg.class_name = name;
    },
    changeQuery(flag) {
      flag && (this.thePage = 1);
      this.$router.replace({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          page: this.thePage,
          create_time: this.dateSelVal,
          status: this.statuSelVal,
          class_level: this.calssLevelSelVal,
          class_train_type: this.calssTrainTypeSelVal
        }
      });
      this.getList();
    },
    loadStuAcc() {
      loadStuAccount({ c_id: this.classId }).then(({ data }) => {
        if (data.status === correctStatus) {
          downfile(data.result.file_url);
        } else {
          this.$message.error(`下载失败, ${data.msg}`);
        }
      });
    },
    doSubmit(classTypeFlag) {
      this.$refs["levelForm"].validate((valid) => {
        if(valid) {
          if(classTypeFlag) {
            // 创建五人制培训班
            this.$router.push({
              name: "CreateTrainingClassFive",
              params: {
                status: 'New',
                level: this.levelForm.level,
              }
            });
          } else {
            // 创建十一人制培训班
            this.$router.push({
              name: "CreateTrainingClass",
              params: {
                status: 'New',
                level: this.levelForm.level,
              }
            });
          }

        }
      });
    },
    doCancel() {
      this.levelFlag = false;
      this.$set(this.levelForm, "level", "");
      setTimeout(() => {
        this.$refs["levelForm"].clearValidate();
      }, 0);
    },
    gotoEnrollList(){
      this.$router.push("EnrollList")
    },
    viewDocuments(){
      this.$router.push({
        path: "documents",
        query: {
          idx:2,
          object_type:"organ"
        }
      });
    },
    jumpToStatistical() {
      this.$router.push({
        path: "/display-club",
      });
    },
    addFunc() {
      this.add_show = true
    },
    hideAddDocumentTips(bool,flag){
      this.add_show = bool;
      if (flag){
        this.$message.success('添加成功！')
      }
    },
    // 检查文件存档是否存在
    checkDocumentExit() {

      const params = {
        page: 1,
        keywords: '',
        id_number: '',
        object_type: 'organ',  // class organ
      };
      getDocumentList(params).then(({ data })=> {
        if(data.status === 0){
          const { page } = data.result;
          if(page.total_row) {

            this.isDocumentExit = true;
          }else {

            this.isDocumentExit = false
          }
        } else {
          console.error('getDocumentList request error')
        }
      }).catch(err =>{
        console.log('err',err)
      })
    },

    goForHeighClassPlane() {
      this.$router.push({
        path: 'address_model'
      })
    },

    // 开班计划
    goForClassPlane() {
      this.$router.push({
        path: 'class_plan_list'
      })
    },
  },
  computed: {
    ...mapGetters(["getStoreOrgData"]),
    isShowStatistical() {
      const { is_statistical } = this.orgInfo;
      return is_statistical ? true : false
    }
  }
};
</script>

<style lang="stylus">
@import '~@/assets/css/variable'
@import '~@/assets/css/mixin'

$right-box-space = 20px
$page_main_height = 680px
.whitebd{
  border:1px solid #fff;
  background: none;
}

.whitebd:hover{
  background: $color_primary
}
.traing_manager-root
  zuxie-page-root()
  .main-content-wrap
    layout-rl($page_main_height)
    color $color_white
    .left-wrap
      display flex
      width $main_left_h
      background-color $block_bg_color_base
      flex-direction column
      align-items center
      padding 10px 10px 20px
      font-size $font_size_medium
      line-height inherit
      .traing-logo
        display block
        // width 120px
        width 90px
        height @width
        margin-bottom 20px
        border-radius 100%
      .text-line
        display block
        text-align center
        font-size $font_size_big
      .traing-name
        margin-bottom 6px
        word-break break-all
        width 100%
        /*padding 0 10px*/
      .traing-num
        margin-bottom 15px
      .create-btn
        width 140px
        margin-bottom 10px
      .train-btn
        width 140px
        margin-bottom 10px
        padding 10px 0px
      .learner-btn
        width 140px
        margin-bottom 10px
      .download-btn,.goto_enroll_list
        width 140px
        /*text-align center*/
        padding-left 12px
        margin-bottom 10px

      /*.goto_enroll_list*/
        /*padding-left 20px*/
      .down-btn
        margin-top 10px
        width 120px
        font-size $font_size_base
    .right-wrap
      display flex
      position relative
      width $main_right_h
      background-color $block_bg_color_base
      padding-top 15px
      padding-bottom 20px
      flex-direction column
      .empty-box
        position absolute
        top 50%
        transform translateY(-50%)
      .content-header
        display flex
        flex 0 0 auto
        align-items center
        justify-content space-between
        margin-right $right-box-space
        margin-left $right-box-space
        padding-bottom 15px
        font-size $font_size_medium
        border-bottom 1px solid $color_white
        .title
          font-size 22px
          font-weight bolder
          line-height 1
        .input-group-wrap
          color $color_black
          .select
            height 34px
            border 1px solid #999
            padding 0 10px
            outline 0
          .date
            width 150px
            margin-right 10px
          .statu
            width 150px
          .level
            width 147px
            margin-right 10px
          .classType
            width 150px
            margin-right 10px
      .list-wrap
        position relative
        // flex 1
        height 560px
        display block
        overflow hidden
        .scroll-wrap
          display block
          width 100%
          height 100%
          padding-top 15px
          padding-bottom 15px
          // overflow hidden
          .list-content
            display block
            padding-left $right-box-space
            padding-right $right-box-space
            .traing-wrap
              margin-bottom 15px
              &:last-child
                margin-bottom 0
              .detail-btn
                width 115px
                font-size $font_size_base
                padding 10px 0
              .result-btn
                display block
    .pagation-wrap
      padding-top 10px
      flex 0 0 auto
    .eval-dialog
      .to-eval
        font-size 16px
        text-align center
        img
          width 100px
        .tips
          margin-bottom 15px
.select-level {
  padding: 10px 0;
  .title {
    font-size: $font_size_big;
  }
  .radio-wrap {
    padding: 40px 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .btns {
    display: flex;
    justify-content: center;
  }
}
.w150 {
  width 165px !important
}
</style>

<style lang="stylus">
  .traing_manager-root
    .el-badge__content.is-fixed.is-dot{
      right 0px
    }
</style>
